import { query } from '@/utils/request';

// 云平台授权列表
export async function getSupplierList(params) {
  return query('/zlb/api/pay/bankCard/queryPageSupplierAccount', { params });
}

// 保存供应商
export async function saveSupplier(data) {
  return query('/zlb/api/pay/bankCard/saveSupplierBankCard', { method: 'POST', data });
}

// 获取导出结果
export const updateSupplier = async data => {
  return query('/zlb/api/pay/bankCard/supplier/update', { method: 'POST', data });
};

// 删除供应商
export async function deleteSupplier(data) {
  return query(`/zlb/api/pay/bankCard/delete/${data.accountCode}`, { method: 'POST' });
}

// 导出收款账户
export async function exportBankCardList(data) {
  return query('/zlb/api/pay/bankCard/export', { method: 'POST', data });
}

// 获取导出结果
export const getBankCardExportResult = async params => {
  return query('/zlb/api/pay/bankCard/export/result', { params });
};

// 导出账户校验结果
export const exportBankCardCheckResult = async data => {
  return query('/zlb/api/pay/bankCard/check/export', { method: 'POST', data });
};

// 获取导出账户校验结果
export const getBankCardCheckResult = async params => {
  return query('/zlb/api/pay/bankCard/check/export/result', { params });
};

/**
 * 批量添加银行卡
 * @param {*} data
 * @returns
 */
export const submitBatchBankCard = data => {
  return query('/zlb/api/pay/bankCard/batch/saveSupplierBankCard', {
    method: 'post',
    data,
  });
};
/**
 * 检测银行卡是否正确
 * @param data
 * @returns
 */
export const checkBankCard = data => {
  return query('/zlb/api/pay/bankCard/getBankInfo', {
    method: 'post',
    data,
  });
};

// 批量删除供应商
export async function batchDeleteSupplier(data) {
  return query('/zlb/api/pay/bankCard/delete/batch', {
    method: 'POST',
    data,
  });
}
